import React, { useEffect, useState } from "react";
import { Edit, Trash2, Plus } from "lucide-react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import "./District.css";

const url = process.env.REACT_APP_BACKEND_URL;

const DistrictList = () => {
  const [districts, setDistricts] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const fetchDistricts = async () => {
    try {
      const res = await axios.get(`${url}/api/district`);
      setDistricts(res.data.data || []);
    } catch (err) {
      toast.error(err.response?.data?.message || "Failed to fetch districts");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDistricts();
  }, []);

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this district?")) {
      try {
        await axios.delete(`${url}/api/district/${id}`);
        toast.success("District deleted successfully");
        fetchDistricts();
      } catch (err) {
        toast.error(err.response?.data?.message || "Failed to delete district");
      }
    }
  };

  if (loading) return <div className="loading">Loading districts...</div>;

  return (
    <div className="district-container">
      <div className="header">
        <h2>Districts List</h2>

        <button
          onClick={() => navigate("/addDistrict")}
          className="add-button"
        >
          <Plus size={16} /> Add District
        </button>
      </div>

      <div className="district-list">
        <table>
          <thead>
            <tr>
              <th>Name</th>
              <th>Country</th>
              <th>Region</th>
              <th>Actions</th>
            </tr>
          </thead>

          <tbody>
            {districts.length === 0 ? (
              <tr>
                <td colSpan="4" className="no-data">
                  No districts found
                </td>
              </tr>
            ) : (
              districts.map((district) => (
                <tr key={district._id}>
                  <td>{district.name}</td>
                  <td>{district.country?.name || "N/A"}</td>
                  <td>{district.region?.name || "N/A"}</td>

                  <td>
                    <div className="actions">
                      <button
                        onClick={() =>
                          navigate(`/district/edit/${district._id}`)
                        }
                        className="edit"
                        title="Edit"
                      >
                        <Edit size={16} />
                      </button>

                      <button
                        onClick={() => handleDelete(district._id)}
                        className="delete"
                        title="Delete"
                      >
                        <Trash2 size={16} />
                      </button>
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default DistrictList;